// extracted by mini-css-extract-plugin
export var content = "PostGridItem-module--content--8+6VV";
export var date = "PostGridItem-module--date--KsjOS";
export var excerpt = "PostGridItem-module--excerpt--h-NC8";
export var postGridItem = "PostGridItem-module--post-grid-item--fXt6A";
export var title = "PostGridItem-module--title--XBcOu";